export const TEXT = {
  SUBTITLE_DELIVERY_DATE: {id: 'mylk.stepper.subtitle.delivery_date'},
  SUBTITLE_DELIVERED: {id: 'mylk.stepper.subtitle.delivered'},
  STEP_1_TITLE: {id: 'mylk.stepper.step_1.title'},
  STEP_1_DESCRIPTION: {id: 'mylk.stepper.step_1.description'},
  STEP_2_TITLE: {id: 'mylk.stepper.step_2.title'},
  STEP_2_DESCRIPTION: {id: 'mylk.stepper.step_2.description'},
  STEP_3_TITLE_PREVIEW_SEND: {id: 'mylk.stepper.step_3.title.preview_send'},
  STEP_3_DESCRIPTION_PREVIEW_SEND: {id: 'mylk.stepper.step_3.description.preview_send'},
  STEP_3_TITLE_PREVIEW_NOTIFIED: {id: 'mylk.stepper.step_3.title.preview_notified'},
  STEP_3_DESCRIPTION_PREVIEW_NOTIFIED: {id: 'mylk.stepper.step_3.description.preview_notified'},
  STEP_3_TITLE_PREVIEW_SUBMITTED: {id: 'mylk.stepper.step_3.title.preview_submitted'},
  STEP_3_DESCRIPTION_PREVIEW_SUBMITTED: {id: 'mylk.stepper.step_3.description.preview_submitted'},
  STEP_3_TITLE_PREVIEW_EXPIRED: {id: 'mylk.stepper.step_3.title.preview_expired'},
  STEP_3_DESCRIPTION_PREVIEW_EXPIRED: {id: 'mylk.stepper.step_3.description.preview_expired'},
  STEP_4_TITLE: {id: 'mylk.stepper.step_4.title'},
  STEP_4_DESCRIPTION: {id: 'mylk.stepper.step_4.description'},
  STEP_5_TITLE: {id: 'mylk.stepper.step_5.title'},
  STEP_5_DESCRIPTION: {id: 'mylk.stepper.step_5.description'},
  MODAL_LINK: {id: 'mylk.stepper.link'},
};
